<mat-card class="outfit">

  @if (outfit.img) {
    <img class="outfit-img" [src]="outfit.img" alt="photo of {{outfit.name}} outfit">
  }
  <!-- If outfit.img is not present, display a horizontal list of garment images -->
  @if (!outfit.img) {
    <div class="garments-list">
      @for (garment of outfit.garments; track garment) {
        <img [src]="garment.img" alt="photo of {{garment.name}}">
      }
    </div>
  }

  <a mat-button color="primary" [routerLink]="['/outfit/', outfit.id]" routerLinkActive="active"
    ariaCurrentWhenActive="page">
    {{outfit.name}}
  </a>

  <p>{{outfit.type}} - {{calculateDaysSinceLastWorn(outfit.date)}} days ago</p>

</mat-card>